import React from 'react';
import request from 'utils/request';
import reportError from 'utils/report-error';
import { find, findIndex, isNull } from 'lodash';
import { hot } from 'react-hot-loader';

import { intakeQuestionsLoadedEvent, studentFiltersAppliedEvent } from 'utils/events';
import { NotificationCenter } from 'utils/types';

import { Button } from 'semantic-ui-react';

import IntakeQuestionPanel from './question/IntakeQuestionPanel';

import { MAX_APPLICABLE_INTAKE_FILTERS } from './policy';

import intakeQuestionFilterCss from './IntakeQuestionFilterPanel.scss';

const fetchQuestions = () => {
  return request.fetchAuthenticatedStarfishJSON('../instructor/getActiveIntakeQuestionsByQuestionType.html', 'questions', {
    method: 'POST'
  });
};

class IntakeQuestionFilterPanelComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: null,
      selections: [],
      filteredSelections: []
    };
  }

  componentDidMount() {
    if (this.props.notificationCenter) {
      this.props.notificationCenter.addListener(studentFiltersAppliedEvent, this.handleIntakeFiltersApplied.bind(this));
    }

    fetchQuestions()
      .then((questions) => this.setQuestions(questions))
      .catch(reportError);
  }

  componentWillUnmount() {
    if (this.props.notificationCenter) {
      this.props.notificationCenter.removeListener(studentFiltersAppliedEvent, this.handleIntakeFiltersApplied);
    }
  }

  addItemToSelections = (newItem, selections) => {
    const currentSelectionIndex = findIndex(selections, selection => selection.questionId === newItem.questionId);
    if (currentSelectionIndex === -1) {
      return selections.length < MAX_APPLICABLE_INTAKE_FILTERS ? selections.concat([newItem]) : selections;
    }
    return [
      ...selections.slice(0, currentSelectionIndex),
      newItem,
      ...selections.slice(currentSelectionIndex + 1)
    ];
  };

  setQuestions(questions) {
    this.setState({questions});

    if (this.props.notificationCenter) {
      this.props.notificationCenter.fireEvent(intakeQuestionsLoadedEvent, questions);
    }
  }

  handleIntakeFiltersApplied = ({intakeElements}) => {
    if (!intakeElements || intakeElements === this.state.selections) {
      return;
    }

    this.setState({selections: intakeElements});
  };

  filterStudentsByIntakeQuestions = () => {
    if (this.state.selections !== this.state.filteredSelections) {
      this.props.notificationCenter.fireEvent(studentFiltersAppliedEvent, {intakeElements: this.state.selections});

      this.setState({filteredSelections: this.state.selections});
    }
  };

  addSelection = (selection) => {
    this.setState({ selections: this.addItemToSelections(selection, this.state.selections) });
  };

  removeSelection = (selectionId) => {
    this.setState({
      selections: this.state.selections.filter(selection => selection.questionId !== selectionId)
    });
  };

  isEnabled = (selectionId) => {
    return this.state.selections.length < MAX_APPLICABLE_INTAKE_FILTERS ||
      findIndex(this.state.selections, selection => selection.questionId === selectionId) > -1;
  };

  getValue(questionId) {
    const selectedFilter = find(this.state.selections, selection => selection.questionId === questionId);
    if (!selectedFilter) {
      return void 0;
    }
    return selectedFilter.value;
  }

  get studentFilterDisabled() {
    return this.state.selections.length === 0 || ((this.state.filteredSelections.length > 0) &&
      (this.state.filteredSelections === this.state.selections));
  }

  renderQuestion = (question) => {
    return (
      <IntakeQuestionPanel key={question.id}
                           question={question}
                           value={this.getValue(question.id)}
                           enabled={this.isEnabled(question.id)}
                           addSelection={this.addSelection}
													 selectionCount={this.state.selections.length}
                           removeSelection={this.removeSelection}
                           onSubmit={this.filterStudentsByIntakeQuestions} />
    );
  };

  render() {
    if (isNull(this.state.questions)) {
      return <div>Loading...</div>;
    }

    return (
      <div className="sf-intake-filter-sidebar">
        <Button className={this.studentFilterDisabled  ? `intake-filter ${intakeQuestionFilterCss['filter-by-intake-questions']}` : `intake-filter ${intakeQuestionFilterCss['active']}`}
          onClick={this.filterStudentsByIntakeQuestions}
          disabled={this.studentFilterDisabled}>
        {"Filter Students"}
        </Button>

        <div className="sf-intake-filter">
          {this.state.questions.map(this.renderQuestion)}
        </div>
      </div>
    );
  }
}

IntakeQuestionFilterPanelComponent.propTypes = {
  notificationCenter: NotificationCenter,
};

export const IntakeQuestionFilterPanel = hot(module)(IntakeQuestionFilterPanelComponent);
